export default {
  path: '/dashboard',
  name: 'Dashboard',
  hideInMenu: false,
  meta: { icon: 'pie-chart', title: '平台概览', bread: true },
  component: () =>
    import(/* webpackChunkName: 'dashboard' */ '@/views/dashboard/index.vue')
}